import React from 'react';
import { ComposerSendArrowIcon } from './ComposerSendArrowIcon';

export type ChatComposerProps = {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onSend: () => void;
  onStop?: () => void;
  isStreaming?: boolean;
  disabled?: boolean;
  placeholder: string;
  minRows: number;
  docked?: boolean;
};

// S2_Icon_Stop_20_N — Spectrum 2 stop icon (rounded square outline, 16×16 viewBox)
function StopIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M 13.75 16 L 2.25 16 C 1.0092799663543701 16 0 14.990229964256287 0 13.75 L 0 2.25 C 0 1.0097700357437134 1.0092799663543701 0 2.25 0 L 13.75 0 C 14.99072003364563 0 16 1.0097700357437134 16 2.25 L 16 13.75 C 16 14.990229964256287 14.99072003364563 16 13.75 16 Z M 2.25 1.5 C 1.836430013179779 1.5 1.5 1.8369100093841553 1.5 2.25 L 1.5 13.75 C 1.5 14.163089990615845 1.836430013179779 14.5 2.25 14.5 L 13.75 14.5 C 14.163569986820221 14.5 14.5 14.163089990615845 14.5 13.75 L 14.5 2.25 C 14.5 1.8369100093841553 14.163569986820221 1.5 13.75 1.5 L 2.25 1.5 Z" />
    </svg>
  );
}

export function ChatComposer({
  value,
  onChange,
  onKeyDown,
  onSend,
  onStop,
  isStreaming,
  disabled,
  placeholder,
  minRows,
  docked
}: ChatComposerProps) {
  const canSend = Boolean(value.trim()) && !disabled;

  return (
    <div
      className={['rau-composer', docked ? 'rau-composer--docked' : '']
        .join(' ')
        .trim()}
    >
      <div className="rau-composer-field">
        <textarea
          className="rau-composer-input"
          rows={minRows}
          placeholder={placeholder}
          value={value}
          onChange={e => {
            onChange(e.target.value);
            const el = e.target;
            el.style.height = 'auto';
            el.style.height =
              Math.min(el.scrollHeight, docked ? 112 : 120) + 'px';
          }}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
        <div className="rau-composer-toolbar">
          <div className="rau-composer-toolbar-spacer" aria-hidden="true" />
          {isStreaming ? (
            <button
              type="button"
              className="rau-composer-send"
              onClick={onStop}
              aria-label="Stop response"
            >
              <span className="rau-composer-send-icon">
                <StopIcon />
              </span>
            </button>
          ) : (
            <button
              type="button"
              className={`rau-composer-send ${
                !canSend ? 'rau-composer-send--disabled' : ''
              }`}
              onClick={onSend}
              disabled={!canSend}
              aria-label="Send message"
            >
              <span className="rau-composer-send-icon">
                <ComposerSendArrowIcon />
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
